import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import KanbanView from "./kanbanView";
import CalendarView from "./calendarView";
import Tasks from "@/pages/tasks";
import useProjectDetail from "@/api/query/useProjectDetailQuery";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import {
  PlanTypeEnumSchema,
  ProjectDefaultViewEnumValue,
  TaskDependenciesEnumValue,
  TaskStatusEnumValue,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import kanaban from "../../assets/v2/svg/Kanban.svg";
import gantt from "../../assets/v2/svg/Gantt.svg";
import calendar from "../../assets/v2/svg/Calendar.svg";
import list from "../../assets/v2/svg/List.svg";
import {
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  Tooltip,
} from "@/components/ui/tooltip";
import TaskFilter from "./TaskFilter";
import useAllTaskQuery from "@/api/query/useAllTaskQuery";
import { FIELDS } from "@/api/types/enums";
import { Task } from "@/api/mutation/useTaskCreateMutation";
import { Button } from "../ui/button";
import SettingIcon from "@/assets/v2/svg/darkSetting.svg";
import Expand from "@/assets/v2/svg/expand.svg";
import Collaps from "@/assets/v2/svg/collaps.svg";
import Loader from "../common/Loader";
import NoTask from "@/pages/tasks/NoTask";
import TaskSubTaskForm from "../tasks/taskSubTaskForm";
import useAllKanbanColumnQuery from "@/api/query/useAllKanbanColumn";
import { useTranslation } from "react-i18next";
import useMultipaleTaskRemoveMutation from "@/api/mutation/useMultipleTaskRemoveMutation";
import { toast } from "react-toastify";
import { errorConfig } from "@/lib/toastError";
import Dialog from "../common/Dialog";
import TrashCan from "@/assets/svg/TrashCan.svg";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import useTaskMemberListQuery from "@/api/query/useTaskMemberListQuary";
import UserAvatar from "../ui/userAvatar";
import useAssingUserToMultiTaskMutation from "@/api/mutation/useAssingUserToMultiTaskMutation";
import { useUser } from "@/hooks/useUser";
import Gannt from "./custom";
import ZoomOut from "@/assets/v2/svg/zoom-out.svg";
import ZoomIn from "@/assets/v2/svg/zoom-in.svg";
import FullScreen from "@/assets/v2/svg/full-screen.svg";
import ExitFullscreen from "@/assets/svg/ExitFullscreen.svg";
import Refresh from "@/assets/v2/svg/refresh.svg";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import ExcelJS from "exceljs";
import ExcelIcon from "@/assets/v2/svg/excel.svg";
import dateFormater from "@/helperFuntions/dateFormater";
import DownLoadIcon from "@/assets/svg/DownLoad.svg";
import WbsImport from "../tasks/wbsImport";
import { useFormik } from "formik";
import {
  addMemberToOrgSchema,
  assignProjectAndRoleToUserSchema,
} from "@backend/src/schemas/organisationSchema";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { z } from "zod";
import useAddOrganisationMemberMutation from "@/api/mutation/useAddOrganisationMemberMutation";
import { usePlanValidation } from "@/hooks/usePlan";
import useAssignProjectAndRoleToUserMutation from "@/api/mutation/useAssignProjectAndRoleToUser";
import ShareIcon from "@/assets/svg/Share.svg";
import InputEmail from "../common/InputEmail";
import useOrganisationDetailsQuery, {
  UserOrganisationType,
} from "@/api/query/useOrganisationDetailsQuery";
import ErrorMessage from "../common/ErrorMessage";
import useProjectWithoutCalulationQuery from "@/api/query/useProjectWithoutCalulationQuery";
import {
  canManageProjectTasksAndContent,
  normalizeProjectScope,
} from "@/utils/projectRoleAccess";

export const viewOption = [
  {
    icon: list,
    value: ProjectDefaultViewEnumValue.LIST,
  },
  {
    icon: gantt,
    value: ProjectDefaultViewEnumValue.GANTT,
  },
  {
    icon: kanaban,
    value: ProjectDefaultViewEnumValue.KANBAN,
  },
  {
    icon: calendar,
    value: ProjectDefaultViewEnumValue.CALENDAR,
  },
];

function TaskViews() {
  const location = useLocation();
  const [filter, setFilter] = useSearchParams();

  const { projectId } = useParams();
  const projectQuery = useProjectDetail(projectId, true);
  const getAllProjectQuery = useProjectWithoutCalulationQuery(false);
  const allTaskQuery = useAllTaskQuery(projectId, !!projectId);
  const [filterData, setFilterData] = useState<Task[]>();
  const [kanbanSetting, setKanbanSetting] = useState(false);
  const [filtered, setfilterd] = useState(false);
  const [isOpenPopUp, setIsOpenPopUp] = useState(false);
  const [isOpenWorkLoad, setIsOpenWorkLoad] = useState(() =>
    location.pathname.includes("/workload")
  );
  const [filterUnit, setFilterUnit] = useState(0);
  const [isExpand, setIsExpand] = useState(false);
  const [isGanttExpand, setIsGanttExpand] = useState(false);
  const [remove, setRemove] = useState(false);
  const navigate = useNavigate();

  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  useEffect(() => {
    if (projectQuery.data?.data.data && projectQuery.data.data.data.isActive === false) {
      setShowUpgradeModal(true);
    }
  }, [projectQuery.data?.data.data]);

  const [selectedTask, setSelectedTask] = useState<string[]>([]);
  const viewParam = filter.get("view");
  const defaultProjectView =
    projectQuery.data?.data.data?.defaultView ??
    ProjectDefaultViewEnumValue.GANTT;
  const activeView = useMemo(() => {
    if (viewParam && viewOption.some((item) => item.value === viewParam)) {
      return viewParam;
    }
    return defaultProjectView;
  }, [viewParam, defaultProjectView]);
  const isKanbanView = activeView === ProjectDefaultViewEnumValue.KANBAN;
  const allKanbanColumn = useAllKanbanColumnQuery(projectId, isKanbanView);
  const { t, i18n } = useTranslation();
  const taskMemberList = useTaskMemberListQuery(projectId ?? "");
  const assingUserToMultiTask = useAssingUserToMultiTaskMutation();
  const { user } = useUser();
  const handleDownloadGanttPdf = useRef<any>(null);
  const prevProjectId = useRef<string | undefined>(projectId);
  useEffect(() => {
    if (prevProjectId.current && prevProjectId.current !== projectId) {
      const task = filter.get("task");
      const next = new URLSearchParams();
      if (viewParam) {
        next.set("view", viewParam);
      }
      if (task) {
        next.set("task", task);
      }
      const hasStaleFilterParams = [...filter.keys()].some(
        (key) => key !== "view" && key !== "task",
      );
      if (hasStaleFilterParams || filter.toString() !== next.toString()) {
        setFilter(next, { replace: true });
      }
    }
    prevProjectId.current = projectId;
    setFilterData(undefined);
  }, [projectId]);

  useEffect(() => {
    const tasks = allTaskQuery.data?.data.data;
    const hasActiveFilters = [...filter.keys()].some(
      (key) => key !== "view" && key !== "task",
    );
    if (tasks && !hasActiveFilters) {
      setFilterData(tasks);
    }
  }, [allTaskQuery.data?.data.data, projectId, filter]);

  useEffect(() => {
    if (!projectId || viewParam) {
      return;
    }
    const next = new URLSearchParams(filter);
    next.set("view", defaultProjectView);
    setFilter(next, { replace: true });
  }, [projectId, viewParam, defaultProjectView, filter, setFilter]);

  // const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  useEffect(() => {
  if (!getAllProjectQuery.isFetched) {
        getAllProjectQuery.refetch()
      }
    }, [getAllProjectQuery.isFetched])
  
  const roleInProject = useMemo(() => {
    const p = projectQuery.data?.data.data;
    const uid = user?.userId;
    if (!p || !uid) return undefined;
    const r = p.assignedUsers.find((u) => u.user.userId === uid)
      ?.projectRole;
    return r as keyof typeof UserRoleEnumValue | undefined;
  }, [projectQuery.data?.data.data, user?.userId]);

  // ─── FIX 2: setView creates NEW URLSearchParams, doesn't mutate ─────────
  const setView = useCallback(
    (view: keyof typeof ProjectDefaultViewEnumValue) => {
      if (view === ProjectDefaultViewEnumValue.GANTT) {
        setIsGanttExpand(true);
      }

      const isWorkloadPath = location.pathname.includes("/workload");
      if (isWorkloadPath && view !== ProjectDefaultViewEnumValue.GANTT) {
        navigate(`/tasks/${projectId}?view=${view}`);
        return;
      }

      // Create NEW URLSearchParams instead of mutating
      const newParams = new URLSearchParams(filter);
      newParams.set("view", view);
      setFilter(newParams);
    },
    [filter, setFilter, location.pathname, navigate, projectId],
  );

  
  useEffect(() => {
    const isWorkloadPath = location.pathname.includes("/workload");
    if (isWorkloadPath && !isOpenWorkLoad) {
      setIsOpenWorkLoad(true);
    }
  }, [location.pathname]);

  // Redirect to /tasks if on /workload path but view is not GANTT
  useEffect(() => {
    const isWorkloadPath = location.pathname.includes("/workload");
    const currentView = filter.get("view");
    if (
      isWorkloadPath &&
      currentView &&
      currentView !== ProjectDefaultViewEnumValue.GANTT
    ) {
      navigate(`/tasks/${projectId}?view=${currentView}`, { replace: true });
    }
  }, [location.pathname, filter, projectId, navigate]);

  // ─── FIX 4: Separate effect for view-specific side effects ──────────────
  // This handles things that should happen when the VIEW changes
  useEffect(() => {
    if (activeView === ProjectDefaultViewEnumValue.GANTT) {
      setIsGanttExpand(true);
    }
  }, [activeView]);
  // ─ Only reacts to view changes, not all filter changes
  useEffect(() => {
    if (isKanbanView) {
      allKanbanColumn.refetch();
    }
    setIsOpenWorkLoad(false);
  }, [projectId, isKanbanView]);

  useEffect(() => {
    if (location?.state?.isGanttOpen) {
      setIsOpenWorkLoad(location?.state?.isGanttOpen);
    }
  }, [location]);

  useEffect(() => {
    if (
      allTaskQuery.data &&
      allTaskQuery.data?.data.data.length > 0 &&
      filterData &&
      filterData.length === 0
    ) {
      setfilterd(true);
    } else {
      setfilterd(false);
    }
    if (
      (allTaskQuery.data?.data?.data?.length ?? -1) === 0 &&
      filterData &&
      filterData.length > 0
    ) {
      setFilterData([]);
    }
  }, [filterData, allTaskQuery.data?.data?.data, allTaskQuery.isStale]);

  const useGetOrganizationUser = useOrganisationDetailsQuery(
    localStorage.getItem("organisation-id") + "", isOpenPopUp
  );
  const multipaleTaskRemoveMutation = useMultipaleTaskRemoveMutation();

  const removetask = () => {
    multipaleTaskRemoveMutation.mutate(
      { taskIds: selectedTask },
      {
        onSuccess: (data) => {
          toast.success(data.data.message);
          setRemove(false);
          allTaskQuery.refetch();
          setSelectedTask([]);
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig,
          );
        },
      },
    );
  };

  const [organizationUsers, setOrganizationUsers] = useState<
    UserOrganisationType[]
  >([]);

  useEffect(() => {
    setOrganizationUsers(
      useGetOrganizationUser.data?.data.data.userOrganisation ?? [],
    );
  }, [useGetOrganizationUser.data?.data.data]);

  const downloadExcel = async (data: Task[]) => {
    const projectName = projectQuery.data?.data.data.projectName || "Project";

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Feuille1");

    worksheet.columns = [
      { header: "ID", key: "id", width: 10 },
      { header: "Activites / Taches", key: "task", width: 40 },
      { header: "Description", key: "description", width: 50 },
      { header: "Successeurs (séparés par virgule)", key: "dependencies", width: 40 },
      { header: "Date de debut (dd/mm/yyyy)", key: "startDate", width: 25 },
      { header: "Duree (optionel)", key: "duration", width: 20 },
      { header: "Date de fin (dd/mm/yyyy)", key: "endDate", width: 25 },
      { header: "Assigné à", key: "assignedTo", width: 25 },
      { header: "Statut", key: "status", width: 18 },
      { header: "Progrès", key: "progress", width: 12 },
      { header: "Jalon", key: "milestone", width: 10 },
    ];

    const statusOptions = ["Non commencé", "Terminé", "En cours"];

    const flattenedTasks: {
      id: string;
      task: string;
      description: string;
      dependencies: string;
      startDate: string;
      duration: number | string;
      endDate: string;
      assignedTo: string;
      status: string;
      progress: string;
      milestone: string;
    }[] = [];

    const taskIdToIdPathMap: Record<string, string> = {};

    const rootTasks = data
      .filter((t) => !t.parentTaskId)
      .sort(
        (a, b) =>
          new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
      );

    // ✅ PASS 1: index ALL tasks first so subtask IDs are available in formatTask
    const indexTasks = (tasks: Task[], prefix = "") => {
      tasks.forEach((task, i) => {
        const idPath = prefix ? `${prefix}.${i + 1}` : `${i + 1}`;
        taskIdToIdPathMap[task.taskId] = idPath;
        if (task.subtasks?.length) indexTasks(task.subtasks, idPath);
      });
    };

    indexTasks(rootTasks);

    // ✅ Your original field direction preserved — only added dedup via seen Set
    const buildPredecessorMap = () => {
      const predecessorMap: Record<string, string[]> = {};
      const seen = new Set<string>();

      data.forEach((task) => {
        if (!task.dependencies) return;

        (task.dependencies as any[])
          .filter((dep) => {
            // Dedup by primary key — blocks the mirror record
            const depPk: string =
              dep.taskDependencyId ??
              dep.id ??
              `${dep.dependentTaskId}__${dep.dependendentOnTaskId}`;

            if (seen.has(depPk)) return false;
            seen.add(depPk);
            return true;
          })
          .forEach((dep) => {
            // ✅ Your original field direction — do not change
            const predecessorTaskId = dep.dependentTaskId;
            const successorTaskId = dep.dependendentOnTaskId;
            if (dep.dependentType !== TaskDependenciesEnumValue.SUCCESSORS)
              return;
            if (!predecessorTaskId || !successorTaskId) return;

            if (!predecessorMap[predecessorTaskId]) {
              predecessorMap[predecessorTaskId] = [];
            }
            predecessorMap[predecessorTaskId].push(successorTaskId);
          });
      });

      return predecessorMap;
    };

    const taskIdToPredecessorsMap = buildPredecessorMap();

    const formatTask = (
      task: Task,
      indexPath: string,
    ): (typeof flattenedTasks)[number] => {
      const mainTask = data.find((t) => t.taskId === task.taskId);
      const assignees = (mainTask?.assignedUsers || [])
        .map((u) => {
          const { email } = u.user || {};
          return email || "";
        })
        .join(" ");

      let status = "Non commencé";
      if (task.status === TaskStatusEnumValue.COMPLETED) status = "Terminé";
      else if (task.status === TaskStatusEnumValue.IN_PROGRESS)
        status = "En cours";

      const endDate = mainTask?.endDate;

      const predecessorIdPaths = (
        taskIdToPredecessorsMap[(mainTask as any)?.taskId] || []
      )
        .map((taskId: string) => taskIdToIdPathMap[taskId])
        .filter(Boolean)
        .join(", ");

      return {
        id: indexPath,
        task: task.taskName,
        description: task.taskDescription || "",
        dependencies: predecessorIdPaths,
        startDate: task.startDate ? dateFormater(task.startDate) : "",
        duration: task.duration || "",
        endDate: dateFormater(new Date(endDate ?? "")),
        assignedTo: assignees,
        status,
        progress: Number(task.completionPecentage).toFixed(),
        milestone: task.milestoneIndicator ? "true" : "false",
      };
    };

    // ✅ PASS 2: format rows (map is fully built)
    const traverseTasks = (tasks: Task[], prefix = "") => {
      tasks.forEach((task, i) => {
        const idPath = prefix ? `${prefix}.${i + 1}` : `${i + 1}`;
        flattenedTasks.push(formatTask(task, idPath));
        if (task.subtasks?.length) {
          traverseTasks(task.subtasks, idPath);
        }
      });
    };

    traverseTasks(rootTasks);

    flattenedTasks.forEach((taskRow) => {
      const row = worksheet.addRow(taskRow);
      const rowNumber = row.number;
      const isParent = /^\d+$/.test(taskRow.id);

      // ✅ Force ID cell to text — prevents "1.10" being coerced to 1.1 by Excel
      const idCell = worksheet.getCell(`A${rowNumber}`);
      idCell.numFmt = "@";
      idCell.value = taskRow.id;

      const startDateCell = worksheet.getCell(`E${rowNumber}`);
      startDateCell.numFmt = "dd/mm/yyyy";
      const endDateCell = worksheet.getCell(`G${rowNumber}`);
      endDateCell.numFmt = "dd/mm/yyyy";

      if (isParent) {
        row.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "B9E1CB" },
          };
          cell.font = { bold: true };
        });
      }
    });

    worksheet.eachRow((_, rowNumber) => {
      if (rowNumber === 1) return;

      worksheet.getCell(`I${rowNumber}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`"${statusOptions.join(",")}"`],
        showErrorMessage: true,
      };

      worksheet.getCell(`J${rowNumber}`).dataValidation = {
        type: "whole",
        operator: "between",
        allowBlank: true,
        showErrorMessage: true,
        formulae: [0, 100],
        errorTitle: "Invalid Progress",
        error: "Progress must be a whole number between 0 and 100",
      };

      // Milestone Column (K)
      worksheet.getCell(`K${rowNumber}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"true,false"'],
        showErrorMessage: true,
      };
    });

    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "62BD8A" },
      };
      cell.font = {
        bold: true,
        color: { argb: "FFFFFF" },
      };
      cell.border = {
        top: { style: "thin", color: { argb: "006400" } },
        left: { style: "thin", color: { argb: "006400" } },
        bottom: { style: "thin", color: { argb: "006400" } },
        right: { style: "thin", color: { argb: "006400" } },
      };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `${projectName}.xlsx`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  };

  const submitMultiTaskAssing = (selectedUser: string) => {
    assingUserToMultiTask.mutate(
      { assignedToUserId: selectedUser, data: { taskIds: selectedTask } },
      {
        onSuccess: (data) => {
          toast.success(data.data.message);
          allTaskQuery.refetch();
          setSelectedTask([]);
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig,
          );
        },
      },
    );
  };

  const fullScreen = useRef<HTMLDivElement | null>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);

      const navbar = document.getElementById("navbar");
      const sidebar = document.getElementById("Sidebar");

      if (document.fullscreenElement) {
        if (navbar) navbar.classList.add("!hidden");
        if (sidebar) sidebar.classList.add("!hidden");
      } else {
        if (navbar) navbar.classList.remove("!hidden");
        if (sidebar) sidebar.classList.remove("!hidden");
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    const taskId = filter.has("task");
    if (taskId) {
      setIsOpenPopUp(true);
    }
  }, [filter]);

  const enterFullscreen = () => {
    const elem = document.documentElement;

    if (!isFullscreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  const [newTask, setNewTask] = useState("");
  // useEffect(() => {
  //   if (allTaskQuery.isStale || !allTaskQuery.isRefetching) {
  //     setDataSource(allTaskQuery.data?.data.data);
  //   }
  // }, [allTaskQuery.data?.data.data]);

  const selectedView = activeView;
  const selectedItem = viewOption.find((item) => item.value === selectedView);
  const projectTasks = allTaskQuery.data?.data.data ?? [];
  const isTasksInitialLoading =
    (allTaskQuery.isLoading || allTaskQuery.isPending) && !allTaskQuery.data;

  const addOrganisationMemberMutation = useAddOrganisationMemberMutation(
    localStorage.getItem("organisation-id") ?? "",
  );
  const assignProjectAndRoleToUserMutation =
    useAssignProjectAndRoleToUserMutation();
  const { validatePlan } = usePlanValidation();

  const addOrgMemberForm = useFormik<z.infer<typeof addMemberToOrgSchema>>({
    initialValues: {
      email: "",
      language: i18n.language.toUpperCase() as "FR" | "EN",
      isAdmin: false,
      isCollaborator: true,
    },
    validationSchema: toFormikValidationSchema(addMemberToOrgSchema),
    onSubmit: (values, helper) => {
      if (!validatePlan("member").valid) {
        return;
      }

      addOrganisationMemberMutation.mutate(
        { ...values, isCollaborator: true },
        {
          onSuccess(data) {
            toast.success(errorKeyFormate(data.data.message));
            projectQuery.refetch();
            helper.resetForm();
            const createData = {
              userOrganisationId:
                data.data.data.userOrganisation[0].userOrganisationId ?? "",
              data: {
                arrayOfRoleAndProjectId: [
                  {
                    projectId: projectId ?? "",
                    projectRoleForUser: UserRoleEnumValue.COLLABORATOR,
                  },
                ],
                isRoleChangePmToTm: false,
                isCollaborator: true,
              },
            };
            assignToProject(createData);
          },
          onError(error) {
            if (error) {
              if (
                error.response?.status === 400 &&
                error.response.data?.errors &&
                Array.isArray(error.response?.data.errors)
              ) {
                error.response.data.errors.forEach((item) => {
                  helper.setFieldError(item.path[0], item.message);
                });
              }
              if (!Array.isArray(error.response?.data.errors)) {
                toast.error(
                  errorKeyFormate(error.response?.data.message + ""),
                  errorConfig,
                );
              }
            }
          },
        },
      );
    },
  });

  const assignToProject = (createData: {
    userOrganisationId: string;
    data: z.infer<typeof assignProjectAndRoleToUserSchema>;
  }) => {
    assignProjectAndRoleToUserMutation.mutate(createData, {
      onSuccess(data) {
        toast.success(errorKeyFormate(data.data.message));
        if (data.data.data.isChargeApplied) {
          toast.success(errorKeyFormate(data.data.data.additionalMessage), {
            autoClose: false,
          });
        }

        projectQuery.refetch();
      },
      onError(error) {
        toast.error(
          error.response?.data.message === "Unauthorized"
            ? t(
                "You are not authorized to edit tasks which are not assigned to you",
              )
            : errorKeyFormate(error.response?.data.message + ""),
          errorConfig,
        );
      },
    });
  };

  const [showViewList, setShowViewList] = useState(false);

  const toggleWorkload = () => {
    if (
      !user?.subscription ||
      !user?.subscription?.planType ||
      user?.subscription?.planType === PlanTypeEnumSchema.FREE
    ) {
      navigate(`/workload/${projectId}?view=GANTT`);
    } else {
      setIsOpenWorkLoad(!isOpenWorkLoad);
    }
  };

  const isOrgAdmin =
    user?.userOrganisation[0]?.role === UserRoleEnumValue.ADMINISTRATOR;

  const canManageInProject = useMemo(() => {
    if (!user || !projectQuery.data?.data.data) return false;
    const p = projectQuery.data.data.data;
    return canManageProjectTasksAndContent(
      user,
      user.userOrganisation[0]?.role,
      p.assignedUsers,
      normalizeProjectScope(p),
    );
  }, [user, projectQuery.data?.data.data]);

  const isCollaborator = roleInProject === UserRoleEnumValue.COLLABORATOR;

  const canSeeSetting = isKanbanView && (isOrgAdmin || !isCollaborator);
  const taskFilter = useMemo(
    () => (
      <TaskFilter
        tasks={allTaskQuery.data?.data.data}
        fieldToShow={[
          FIELDS.ASSIGNED,
          FIELDS.DATE,
          FIELDS.DUESEVENDAYS,
          FIELDS.FLAGS,
          FIELDS.OVERDUEDAYS,
          FIELDS.TODAYDUEDAYS,
          FIELDS.TASK,
          FIELDS.STATUS,
        ]}
        small={selectedTask.length > 0}
        view={activeView}
        filteredData={(data) => {
          if (Array.isArray(data)) {
            setFilterData(data);
          }
        }}
        appleed={(data) => {
          if (data) {
            setIsExpand(true);
          } else {
            setIsExpand(false);
          }
        }}
      />
    ),
    [allTaskQuery.data?.data.data, activeView, selectedTask.length],
  );

  // const ClickHandleDownloadGanttPdf = () => {
  //   if (handleDownloadGanttPdf.current?.handleDownloadGanttPdf) {
  //     setIsGeneratingPdf(true);
  //     handleDownloadGanttPdf.current.handleDownloadGanttPdf();
  //   }
  // };
  const handleDownloadGanttPdfComplete = () => {
    // Hide the loader in the parent when the child's task is done
    // setIsGeneratingPdf(false);
  };
  const displayTasks = filterData ?? projectTasks;
  if (showUpgradeModal) {
    return (
      <Dialog
        isOpen={showUpgradeModal}
        onClose={() => {}}
        modalClass="rounded-lg "
        bgClass="!backdrop-blur-sm"
      >
        <div className="flex flex-col gap-4 p-6 w-96 text-center">
          {(!user?.userOrganisation[0]?.role ||
            user?.userOrganisation[0]?.role ==
              UserRoleEnumValue.COLLABORATOR) ? (
            t("You do not have access to this dashboard with your current plan. Please contact your administrator to upgrade the current plan")
          ) : (
            t("Project dashboard are not available in this plan. Do you want to upgrade your plan?")
          )}
          <div className="flex gap-2 ml-auto">
            {(!user?.userOrganisation[0]?.role ||
              user?.userOrganisation[0]?.role ==
                UserRoleEnumValue.COLLABORATOR) ? (
              <Button
                variant={"outline"}
                onClick={() => {
                  navigate("/projects");
                }}
              >
                {t("ok")}
              </Button>
            ) : (
              <>
                <Button
                  variant={"outline"}
                  onClick={() => {
                    navigate("/projects");
                  }}
                >
                  {t("cancel")}
                </Button>
                <Button
                  variant={"primary"}
                  className="text-white"
                  onClick={() => {
                    navigate("/plans");
                  }}
                >
                  {t("Upgrade")}
                </Button>
              </>
            )}
          </div>
        </div>
      </Dialog>
    );
  }

  return (
    <div ref={fullScreen} className="h-full overflow-hidden bg-white relative">
      <div className="h-full overflow-hidden bg-white">
        {(isTasksInitialLoading ||
          (isKanbanView && allKanbanColumn.isRefetching)) && (
          <Loader className="absolute top-0 left-0 bg-white z-30" />
        )}
        <div className="h-full ml-4 flex flex-col justify-between items-center gap-0 my-1">
          {allTaskQuery.data && allTaskQuery.data.data.data.length > 0 && (
            <div className="flex justify-between items-center w-full mb-2">
              <div className="flex items-center justify-between gap-2 w-full">
                <div className="flex items-center">
                  {selectedTask.length > 0 && (
                    <Button
                      variant={"destructive"}
                      onClick={() => setRemove(true)}
                      className="mx-2"
                      size={"sm"}
                    >
                      {t("remove")}
                    </Button>
                  )}
                  {selectedTask.length > 0 && (
                    <>
                      <Popover>
                        <PopoverTrigger asChild className="w-fit">
                          <Button variant={"outline"} className="" size={"sm"}>
                            {t("Assign to members")}
                          </Button>
                        </PopoverTrigger>
                        <PopoverContent className="w-fit focus:outline-none">
                          <div className="grid gap-4">
                            <div className="space-y-2">
                              <h4 className="font-medium leading-none">
                                {t("members")}
                              </h4>
                            </div>
                            <div>
                              {taskMemberList.data?.data.data.map(
                                (data, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="flex items-center p-1 my-1 gap-4 hover:bg-slate-100 rounded-md"
                                      onClick={() => {
                                        submitMultiTaskAssing(data.user.userId);
                                      }}
                                    >
                                      <UserAvatar
                                        user={data.user}
                                        className="rounded-full"
                                      />
                                      <div>
                                        <div className="">
                                          {data.user.firstName}{" "}
                                          {data.user.lastName}
                                        </div>
                                        <div className="text-sm text-gray-400">
                                          {data.user.email}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                },
                              )}
                            </div>
                          </div>
                        </PopoverContent>
                      </Popover>
                    </>
                  )}
                  {/* ─ FIX: Use handleFilteredData callback to prevent unnecessary renders */}
                  {allTaskQuery.data?.data.data &&
                    allTaskQuery.isFetched &&
                    taskFilter}
                  {
                    <Button
                      variant={"primary"}
                      onClick={() => setIsOpenPopUp(true)}
                      className="text-white"
                      size={"sm"}
                      disabled={
                        canManageInProject
                          ? false
                          : [
                            UserRoleEnumValue.COLLABORATOR,
                            UserRoleEnumValue.TEAM_MEMBER,
                          ].includes(
                            roleInProject as
                              | typeof UserRoleEnumValue.TEAM_MEMBER
                              | typeof UserRoleEnumValue.COLLABORATOR,
                          )
                      }
                    >
                      {t("Add_New_Task")}
                    </Button>
                  }
                </div>
                <div className="flex items-center gap-1">
                  {canSeeSetting && (
                    <div className="my-auto ml-10">
                      <Button
                        variant={"ghost"}
                        size={"sm"}
                        onClick={() => setKanbanSetting(!kanbanSetting)}
                        className="p-2 !h-9 rounded-lg border"
                      >
                        <img src={SettingIcon} className="h-4 mr-2" />
                        {t("setting")}
                      </Button>
                    </div>
                  )}
                  {activeView === ProjectDefaultViewEnumValue.GANTT && (
                    <div className="flex justify-between items-center gap-1 my-2 w-full">
                      {filterData?.some((d) => d.parentTaskId) && (
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger asChild>
                              <li className="flex-1 list-none">
                                <Button
                                  variant={"none"}
                                  onClick={() =>
                                    setIsGanttExpand((prev) => !prev)
                                  }
                                  className="!p-1"
                                  size={"sm"}
                                >
                                  <img
                                    src={!isGanttExpand ? Collaps : Expand}
                                    alt=""
                                    className="w-4 min-w-4"
                                  />
                                </Button>
                              </li>
                            </TooltipTrigger>
                            <TooltipContent>
                              <p className="text-sm">
                                {t(!isGanttExpand ? "expand" : "collapse")}
                              </p>
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      )}
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <li className="flex-1 list-none">
                              <Button
                                variant={"none"}
                                className="select-none !p-1"
                                disabled={filterUnit === 0}
                                onClick={() =>
                                  setFilterUnit((prev) => prev - 1)
                                }
                                size={"sm"}
                              >
                                <img src={ZoomIn} className="w-4 min-w-4" />
                              </Button>
                            </li>
                          </TooltipTrigger>
                          <TooltipContent>
                            <p className="text-sm">{t("zoomin")}</p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <li className="flex-1 list-none">
                              <Button
                                variant={"none"}
                                className="select-none !p-1"
                                disabled={filterUnit === 4}
                                onClick={() =>
                                  setFilterUnit((prev) => prev + 1)
                                }
                                size={"sm"}
                              >
                                <img src={ZoomOut} className="w-4 min-w-4" />
                              </Button>
                            </li>
                          </TooltipTrigger>
                          <TooltipContent>
                            <p className="text-sm">{t("zoomout")}</p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    </div>
                  )}
                  {filterData?.some((d) => d.parentTaskId) &&
                    activeView === ProjectDefaultViewEnumValue.LIST && (
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <li className="flex-1 list-none">
                              <Button
                                variant={"none"}
                                onClick={() => setIsExpand(!isExpand)}
                                className="!p-1"
                                size={"sm"}
                              >
                                <img
                                  src={!isExpand ? Collaps : Expand}
                                  alt=""
                                  className="w-4 min-w-4"
                                />
                              </Button>
                            </li>
                          </TooltipTrigger>
                          <TooltipContent>
                            <p className="text-sm">
                              {t(!isExpand ? "expand" : "collapse")}
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    )}
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <li className="flex-1 list-none">
                          <Button
                            variant={"none"}
                            className="select-none !p-1"
                            onClick={() => enterFullscreen()}
                          >
                            <img
                              src={!isFullscreen ? FullScreen : ExitFullscreen}
                              className="w-4 min-w-4"
                            />
                          </Button>
                        </li>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p className="text-sm">
                          {t(
                            !isFullscreen ? "full_Screen" : "full_exit_screen",
                          )}
                        </p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>

                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <li className="flex-1 list-none">
                          <Button
                            variant={"none"}
                            className="select-none !p-1"
                            onClick={() => allTaskQuery.refetch()}
                            size={"sm"}
                          >
                            <img src={Refresh} className="w-4 min-w-4" />
                          </Button>
                        </li>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p className="text-sm">{t("reload")}</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                  {canManageInProject && (
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <li className="flex-1 list-none">
                              <Popover
                                onOpenChange={(e) => {
                                  if (!e) {
                                    addOrgMemberForm.setFieldError("email", "");
                                  }
                                }}
                              >
                                <PopoverTrigger asChild>
                                  <Button
                                    variant={"none"}
                                    className="select-none !p-1"
                                    size={"sm"}
                                  >
                                    <img
                                      src={ShareIcon}
                                      className="w-4 min-w-4 brightness-0 opacity-60"
                                    />
                                  </Button>
                                </PopoverTrigger>
                                <PopoverContent>
                                  <div className="flex flex-col gap-2">
                                    <h2>{t("Add as Collaborator")}</h2>
                                    <div>
                                      <label className="text-xs">
                                        {t("email")}
                                      </label>
                                      <InputEmail
                                        name="email"
                                        onChange={addOrgMemberForm.handleChange}
                                        onBlur={addOrgMemberForm.handleBlur}
                                      />
                                      <ErrorMessage>
                                        {addOrgMemberForm.touched.email &&
                                          addOrgMemberForm.errors.email}
                                      </ErrorMessage>
                                    </div>
                                    <div className="flex w-full justify-end">
                                      <Button
                                        variant={"primary"}
                                        className="ml-auto"
                                        disabled={
                                          !addOrgMemberForm.values.email ||
                                          !addOrgMemberForm.isValid
                                        }
                                        onClick={() => {
                                          const orgUser =
                                            organizationUsers.find(
                                              (t) =>
                                                t.user.email.trim() ===
                                                addOrgMemberForm.values.email.trim(),
                                            );
                                          if (orgUser) {
                                            const userEmail =
                                              addOrgMemberForm.values.email.trim();

                                            const arrayOfRoleAndProjectId =
                                              getAllProjectQuery.data?.data.data
                                                ?.filter(
                                                  (p) =>
                                                    p.projectId !== projectId,
                                                )
                                                .map((p) => {
                                                  const role =
                                                    p.assignedUsers.find(
                                                      (u) =>
                                                        u.user.email.trim() ===
                                                        userEmail,
                                                    )?.projectRole;

                                                  if (
                                                    role === "ADMINISTRATOR" ||
                                                    role ===
                                                      "PROJECT_MANAGER" ||
                                                    role === "TEAM_MEMBER" ||
                                                    role === "COLLABORATOR"
                                                  ) {
                                                    return {
                                                      projectId: p.projectId,
                                                      projectRoleForUser: role,
                                                    };
                                                  }

                                                  return null;
                                                })
                                                .filter(
                                                  (
                                                    item,
                                                  ): item is {
                                                    projectId: string;
                                                    projectRoleForUser: keyof typeof UserRoleEnumValue;
                                                  } => item !== null,
                                                );

                                            const createData = {
                                              userOrganisationId:
                                                orgUser.userOrganisationId ??
                                                "",
                                              data: {
                                                arrayOfRoleAndProjectId: [
                                                  ...(arrayOfRoleAndProjectId ??
                                                    []),
                                                  {
                                                    projectId: projectId ?? "",
                                                    projectRoleForUser:
                                                      UserRoleEnumValue.COLLABORATOR,
                                                  },
                                                ],
                                                isRoleChangePmToTm: false,
                                                isCollaborator: true,
                                              },
                                            };

                                            assignToProject(createData);
                                          } else {
                                            addOrgMemberForm.handleSubmit();
                                          }
                                        }}
                                      >
                                        {t("submit")}
                                      </Button>
                                    </div>
                                  </div>
                                </PopoverContent>
                              </Popover>
                            </li>
                          </TooltipTrigger>
                          <TooltipContent>
                            <p className="text-sm">
                              {t("shareToCollaborator")}
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    )}
                  <WbsImport
                    projectId={projectId ?? ""}
                    refetch={()=>allTaskQuery.refetch()}
                    iconOnly
                    newTask={(task: Task[]) => {
                      const tasks = task.sort(
                        (a, b) =>
                          new Date(a?.startDate).getTime() -
                          new Date(b?.startDate).getDate(),
                      );
                      setNewTask(tasks[0].taskId);
                    }}
                  />

                  <div>
                    <TooltipProvider>
                      <Tooltip delayDuration={0}>
                        <TooltipTrigger asChild>
                          <li className="flex-1 list-none">
                            <Button
                              variant={"none"}
                              className="border !p-1"
                              onClick={() => downloadExcel(filterData ?? [])}
                              size={"sm"}
                            >
                              <img src={ExcelIcon} className="w-4 min-w-4" />
                              <img
                                src={DownLoadIcon}
                                className="w-2 min-w-2 mt-2"
                              />
                            </Button>
                          </li>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p className="text-sm">{t("export your task")}</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </div>
                  {/* {filter.get("view") === ProjectDefaultViewEnumValue.GANTT && (
                    <Button
                      variant={"outline"}
                      size={"sm"}
                      className="h-fit text-xs py-1 hover:bg-gray-700 hover:text-white"
                      onClick={ClickHandleDownloadGanttPdf}
                      disabled={isGeneratingPdf}
                    >
                      {isGeneratingPdf
                        ? t("generating_pdf")
                        : t("export_gantt_pdf")}
                    </Button>
                  )} */}
                  <Button
                    variant={isOpenWorkLoad ? "primary" : "primary_outline"}
                    onClick={() => {
                      if (
                        activeView === ProjectDefaultViewEnumValue.GANTT
                      ) {
                        toggleWorkload();
                      } else {
                        navigate(
                          `/tasks/${projectId}?view=${ProjectDefaultViewEnumValue.GANTT}`,
                        );
                        setIsOpenWorkLoad(true);
                      }
                    }}
                    className={`h-fit text-xs px-3 py-1.5 shrink-0 whitespace-nowrap font-medium rounded-full transition-all ${
                      isOpenWorkLoad ? "text-white" : ""
                    }`}
                    size={"sm"}
                  >
                    {t("Work load")}
                  </Button>
                </div>
              </div>

              <div className="flex justify-between px-4 items-center">
                <ul className="flex items-center gap-3 text-sm font-medium mr-10">
                  <Popover open={showViewList} onOpenChange={setShowViewList}>
                    <PopoverTrigger asChild className="w-full text-left">
                      <button
                        type="button"
                        className="text-gra relative flex items-center bg-orange justify-center px-3 py-2 h-fit gap-2 rounded-full border text-white"
                      >
                        {selectedItem ? (
                          <>
                            <img
                              src={selectedItem.icon}
                              className="w-4 min-w-4 opacity-70 brightness-0 invert"
                            />
                            <span className="text-sm">
                              {t(selectedItem.value.toLowerCase())}
                            </span>
                          </>
                        ) : (
                          <span className="text-sm">{t("Select View")}</span>
                        )}
                      </button>
                    </PopoverTrigger>

                    <PopoverContent className="p-2">
                      <ul className="space-y-1">
                        {viewOption.map((item) => {
                          const isSelected = item.value === selectedView;
                          return (
                            <TooltipProvider key={item.value}>
                              <Tooltip delayDuration={0}>
                                <TooltipTrigger asChild>
                                  <li>
                                    <button
                                      onClick={() => {
                                        setView(
                                          item.value as keyof typeof ProjectDefaultViewEnumValue,
                                        );
                                        setIsExpand(false);
                                        setSelectedTask([]);
                                        setShowViewList(false);
                                        setIsOpenWorkLoad(false);
                                      }}
                                      className={`text-gra w-full relative flex items-center justify-start px-2 py-1.5 gap-2 rounded-xl hover:text-gray-700 ${
                                        isSelected
                                          ? "bg-orange/50 shadow-md "
                                          : "bg-gray-50"
                                      }`}
                                    >
                                      <img
                                        src={item.icon}
                                        className="w-4 min-w-4"
                                        style={{
                                          filter: isSelected
                                            ? "brightness(100000%)"
                                            : "grayscale(100%) brightness(0%)",
                                        }}
                                      />
                                      <span
                                        className={`text-sm ${
                                          isSelected
                                            ? "text-white font-semibold"
                                            : ""
                                        }`}
                                      >
                                        {t(item.value.toLowerCase())}{" "}
                                        {t("View")}
                                      </span>
                                    </button>
                                  </li>
                                </TooltipTrigger>
                                <TooltipContent>
                                  <p className="text-sm">
                                    {t(item.value.toLowerCase())} {t("View")}
                                  </p>
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          );
                        })}
                      </ul>
                    </PopoverContent>
                  </Popover>
                </ul>
              </div>
            </div>
          )}
          <div className="h-full overflow-hidden px-2 py-0 w-full relative">
            {isTasksInitialLoading ? (
              <Loader className="absolute top-0 left-0 bg-white z-10" />
            ) : !allTaskQuery.data ? (
              <></>
            ) : !projectTasks.length ? (
              // Only show the empty-state when the backend confirms there are zero tasks.
              <div className="w-full h-full bg-white overflow-y-auto">
                <NoTask
                  setIsOpenPopUp={setIsOpenPopUp}
                  key={projectId}
                  projectId={projectId ?? ""}
                  refetch={() => allTaskQuery.refetch()}
                  filtered={filtered}
                />
              </div>
            ) : (
              <div className="h-full w-full">
                {activeView === ProjectDefaultViewEnumValue.KANBAN && (
                  <KanbanView
                    key={`${projectId}-${roleInProject ?? "norole"}-${canManageInProject}`}
                    userRole={roleInProject}
                    canManageProject={canManageInProject}
                    data={displayTasks}
                    openSetting={kanbanSetting}
                    refetch={() => allTaskQuery.refetch()}
                    rowTasksData={allTaskQuery.data?.data.data}
                    projectStatus={projectQuery.data?.data.data?.status}
                    projectAssignedUsers={
                      projectQuery.data?.data.data?.assignedUsers
                    }
                  />
                )}
                {activeView === ProjectDefaultViewEnumValue.LIST && (
                    <Tasks
                      data={displayTasks}
                      expandChild={Boolean(isExpand)}
                      selectedTask={setSelectedTask}
                      key={`${filtered && filterData ? "filtered" : "view"}-${isExpand ? "expand" : "collapse"}`}
                      projectStatus={projectQuery.data?.data.data?.status}
                      projectAssignedUsers={
                        projectQuery.data?.data.data?.assignedUsers
                      }
                    />
                  )}
                {activeView === ProjectDefaultViewEnumValue.CALENDAR && (
                  <CalendarView
                    key={projectId}
                    data={displayTasks}
                    refetch={() => allTaskQuery.refetch()}
                  />
                )}
                {activeView === ProjectDefaultViewEnumValue.GANTT && (
                    <div className="h-full w-full">
                      <Gannt
                        key={filtered + ""}
                        setFilterUnit={setFilterUnit}
                        FilterUnit={filterUnit}
                        data={displayTasks}
                        refetch={() => allTaskQuery.refetch()}
                        expandAll={isGanttExpand}
                        popUpClose={isOpenPopUp}
                        isRefetching={allTaskQuery.isFetching}
                        selectedTaskId={newTask}
                        IsOpenWorkLoad={isOpenWorkLoad}
                        handleDownloadGanttPdfComplete={
                          handleDownloadGanttPdfComplete
                        }
                        ganttPdfRef={handleDownloadGanttPdf}
                        bulkSelectedTaskIds={selectedTask}
                        onBulkSelectedTaskIdsChange={setSelectedTask}
                        bulkSelectionSourceTasks={
                          allTaskQuery.data?.data.data ?? []
                        }
                      />
                    </div>
                  )}
              </div>
            )}
          </div>
        </div>
      </div>
      {isOpenPopUp && (
        <TaskSubTaskForm
          taskId={filter.get("task") ?? ""}
          projectId={projectId}
          close={(taskId) => {
            allTaskQuery.refetch().then(() => {
              setNewTask(taskId);
            });
            setFilter(new URLSearchParams({ view: activeView }));
            setIsOpenPopUp(!isOpenPopUp);
          }}
        />
      )}
      <Dialog isOpen={remove} onClose={() => {}} modalClass="rounded-lg">
        <div className="flex flex-col gap-2 p-6">
          <img src={TrashCan} className="w-12 m-auto" />
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={multipaleTaskRemoveMutation.isPending}
              disabled={multipaleTaskRemoveMutation.isPending}
              onClick={() => setRemove(false)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              className="text-white"
              onClick={removetask}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default TaskViews;
